import { unwrapResult } from '@reduxjs/toolkit'
import { Route } from '../../../config/router'
import { ConsumerAccountResponse, CrossRegionRedirection, Checkout } from '../../../model'
import { AsyncAction, accountLookup, checkPersistentLogin } from '../../../state'
import { determinePersistentLoginRoute, InitialiseNextRoute } from '../routing'

type LoadPersistentConsumerResult = ConsumerAccountResponse | Route.VERIFY | null

const isConsumerAccountResponse = (loadPersistentConsumerResult: LoadPersistentConsumerResult): loadPersistentConsumerResult is ConsumerAccountResponse => {
  return loadPersistentConsumerResult !== null && loadPersistentConsumerResult !== Route.VERIFY
}

const loadPersistentConsumer = (): AsyncAction<LoadPersistentConsumerResult> => async (dispatch) => {
  try {
    const { active, verify } = unwrapResult(await dispatch(checkPersistentLogin()))
    if (active && verify) {
      return Route.VERIFY
    }
    if (active) {
      return unwrapResult(await dispatch(accountLookup()))
    }
  } catch (e) {}
  return null
}

export const handlePersistentLogin = async (
  checkout: Checkout,
  dispatch: (action: any) => any
): Promise<InitialiseNextRoute | CrossRegionRedirection | { route: Route } | null> => {
  const account = await dispatch(loadPersistentConsumer())

  if (account !== null) {
    // Persistent logged-in user
    if (isConsumerAccountResponse(account)) {
      return await determinePersistentLoginRoute({ account, checkout }, dispatch)
    } else {
      // trusted checkout 2fa
      return { route: account as Route.VERIFY }
    }
  }

  return null
}
